/** Whether focus is somewhere the user is typing prose, not driving the app. */
export function isTypingInField(target: Element | null): boolean {
  if (!target) return false
  const tag = target.tagName
  return tag === 'INPUT' || tag === 'TEXTAREA' || (target as HTMLElement).isContentEditable
}

/**
 * Whether a keydown is the send-bundle chord.
 *
 * Matched on `event.code` rather than `event.key`, because `key` is the
 * produced character — uppercase `'B'` whenever Shift is down, and a different
 * character entirely on a non-QWERTY layout. `code` is the physical key, so
 * every user presses the same chord.
 *
 * Auto-repeat is excluded: holding the chord would otherwise fire a capture per
 * repeat, and capture happens on the keystroke, before the dialog exists to
 * throttle anything.
 *
 * Callers must `preventDefault()` on a match — Ctrl+Shift+B toggles the
 * browser's bookmarks bar.
 */
export function matchesBundleShortcut(event: KeyboardEvent): boolean {
  if (event.repeat) return false
  if (event.code !== 'KeyB') return false
  if (!event.shiftKey) return false
  if (event.altKey) return false
  return event.ctrlKey || event.metaKey
}
